import { announceSignOut } from '@/lib/api/request-scope'
import { logoutSession } from '@/lib/auth/logout-session'
import { createLogger } from '@/lib/logger'
import { isTauri } from '@/lib/utils/tauri'
import { resetPersistedModuleFilters } from '@/store/filter-scope'
import { toast } from 'sonner'

import { SessionChangedError } from '@scrambl/shared/session-scope'

const logger = createLogger('utils/auth/auth-utils')

/** Standard sign-out that preserves unrelated device preferences/accounts. */
export async function handleLogout() {
  try {
    const completion = await logoutSession()
    completion.assertCurrent()
    if (isTauri()) {
      try {
        const [{ browserNotificationService }, tauriModule] = await Promise.all(
          [
            import('@/services/browserNotificationService'),
            import('@/lib/utils/tauri'),
          ],
        )
        completion.assertCurrent()
        await browserNotificationService.clearBadgeCount()
        completion.assertCurrent()
        await tauriModule.setTrayTitle(null)
      } catch (error) {
        if (error instanceof SessionChangedError) throw error
        logger.error('[Auth] Failed to clear desktop badge/tray state:', error)
      }
      completion.assertCurrent()
    }
    resetPersistedModuleFilters()
    const keys = [
      'currentOrganizationId',
      'currentUserId',
      'pendingInviteToken',
      'invitedOrganizationName',
      'scrambl-login-session',
      'organization-store',
      'organization-invite-store',
      'user-profile-storage',
    ]
    Object.keys(localStorage).forEach(key => {
      if (keys.includes(key) || key.startsWith('user-profile-image-'))
        localStorage.removeItem(key)
    })
    sessionStorage.clear()
    announceSignOut()
    window.location.replace('/login')
  } catch (error) {
    if (error instanceof SessionChangedError) return
    logger.error('[Auth] Sign out could not be completed:', error)
    toast.error('Sign out could not be completed. Try again.', {
      action: { label: 'Retry', onClick: () => void handleLogout() },
    })
  }
}
